import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ toasts, onClose }) => {
  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="toast-enter"
          style={{
            animation: 'slideInUp 0.3s ease-out forwards'
          }}
        >
          <Toast
            id={toast.id}
            type={toast.type}
            message={toast.message}
            onClose={onClose}
            duration={toast.duration}
          />
        </div>
      ))}
      
      <style jsx>{`
        @keyframes slideInUp {
          from {
            transform: translateY(100%) translateX(0);
            opacity: 0;
          }
          to {
            transform: translateY(0) translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes slideOutDown {
          from {
            transform: translateY(0) translateX(0);
            opacity: 1;
          }
          to {
            transform: translateY(100%) translateX(0);
            opacity: 0;
          }
        }
        
        .toast-enter {
          animation: slideInUp 0.3s ease-out forwards;
        }
        
        .toast-exit {
          animation: slideOutDown 0.3s ease-in forwards;
        }
        
        .toast-notification:hover {
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default ToastContainer;
